export default __webpack_public_path__ + "static/whatsapp-9aa2a760469692394b9dfb1c8cae0363.png";